import React from 'react'
import PropTypes from 'prop-types'
import CmsModules from '../../../leap/modules'
import {Chakra3Theme} from '../../../leap/theme'

const PdpCmsModules = ({assetId, theme = 'light'}) => (
    <Chakra3Theme theme={theme}>
        <CmsModules assetId={assetId} />
    </Chakra3Theme>
)

PdpCmsModules.propTypes = {
    assetId: PropTypes.string,
    theme: PropTypes.oneOf(['light', 'dark'])
}

export default PdpCmsModules
